'use strict';
/**
 * @ngdoc function
 * @name thothAppApp.directive:pagination
 * @description
 * # pagination
 * Directive to generate a pagination form
 */
angular.module('thothApp.directives', [])
.directive('pagination', function() {
  return {
    restrict: 'E',
    scope: {
      pager: '=',
      getPage: '&'
    },
    templateUrl: 'views/_pagination.html'
  };
});
